module.exports = __webpack_public_path__ + "static/media/about3.dd480fe3.png";